import { useEffect } from 'react';
import { hardLogout, logout } from '../../utils/auth';
import { isMobileApp } from '../../utils';

const isMobile = isMobileApp();

const Logout = () => {
  useEffect(() => {
    if (isMobile) {
      hardLogout();
    } else {
      logout();
    }
  }, []);

  return null;
};

export default Logout;
